import { Component, inject, OnInit, signal } from '@angular/core';
import { Location } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { trigger, transition, style, animate } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { PRIVACY_POLICY, TERMS_OF_USE } from './texts';

@Component({
  selector: 'app-agreements',
  imports: [MatTabsModule],
  templateUrl: './agreements.component.html',
  styleUrl: './agreements.component.scss',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('450ms 250ms ease-in', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('300ms ease-out', style({ opacity: 0 }))]),
    ]),
  ],
})
export class AgreementsComponent implements OnInit {
  privacyPolicyText = PRIVACY_POLICY;
  termsOfUse = TERMS_OF_USE;
  router = inject(Router);
  route = inject(ActivatedRoute);
  listItems = ['Privacy Policy', 'Terms of Use'];
  activeIndex = signal(0);

  ngOnInit(): void {
    this.route.firstChild?.url.subscribe({
      next: (url) => {
        const currentPath = url[0]?.path;
        this.activeIndex.set(Number(currentPath === 'terms-of-use'));
      },
      error: (err) => {
        this.activeIndex.set(0);
      },
    });
  }

  setActiveIndex(index: number): void {
    this.activeIndex.set(index);
  }

  navigateHome() {
    this.router.navigate(['/home']);
  }
}
